import { render, staticRenderFns } from "./WidgetData.vue?vue&type=template&id=624579ce"
import script from "./WidgetData.vue?vue&type=script&lang=js"
export * from "./WidgetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports